/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Standing of the building — 1 = standard (2 000 €/m²), 2 = good standing (2 250 €/m²), 3 = luxury (2 500 €/m²). Fixes the SMP rebuild value per m².
 * @export
 */
export const BuildingStanding = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;
export type BuildingStanding = typeof BuildingStanding[keyof typeof BuildingStanding];


export function instanceOfBuildingStanding(value: any): boolean {
    for (const key in BuildingStanding) {
        if (Object.prototype.hasOwnProperty.call(BuildingStanding, key)) {
            if (BuildingStanding[key as keyof typeof BuildingStanding] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BuildingStandingFromJSON(json: any): BuildingStanding {
    return BuildingStandingFromJSONTyped(json, false);
}

export function BuildingStandingFromJSONTyped(json: any, ignoreDiscriminator: boolean): BuildingStanding {
    return json as BuildingStanding;
}

export function BuildingStandingToJSON(value?: BuildingStanding | null): any {
    return value as any;
}

export function BuildingStandingToJSONTyped(value: any, ignoreDiscriminator: boolean): BuildingStanding {
    return value as BuildingStanding;
}

